export default __webpack_public_path__ + "static/media/Smart.d7c9095c.png";